/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersDetailsQuery } from '../../models/get-orders-details-query';
import { GetOrdersDetailsQueryResult } from '../../models/get-orders-details-query-result';

export interface ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain$Params {
      body?: GetOrdersDetailsQuery
}

export function apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrdersDetailsQueryResult>;
    })
  );
}

apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain.PATH = '/api/NurseryManager/OrderDetails/GetOrdersDetails';
